export { default } from './DiscontinuedProductAlert'
